import { PlayRadiusDimension } from "api/ipdp";

import { XDA_RADIUS_TYPES } from "components/vis/context/types";

export interface DimensionFieldDescriptor {
  key: string;
  label: string;
  unit: string;
}

export const RADIUS_SECTIONS = [
  XDA_RADIUS_TYPES.Gross,
  XDA_RADIUS_TYPES.LandingZone,
  XDA_RADIUS_TYPES.SweetSpot
];

export function getDimensionFields(displayUnit: string): DimensionFieldDescriptor[] {
  return [
    { key: "leftWidth", label: "Left Width", unit: displayUnit },
    { key: "rightWidth", label: "Right Width", unit: displayUnit },
    { key: "upHeight", label: "Up Height", unit: displayUnit },
    { key: "downHeight", label: "Down Height", unit: displayUnit }
  ];
}

/** Convert all numeric dimension values from the backend base unit (m) to the display unit. */
export function convertDimensionsToDisplay(
  dimensions: PlayRadiusDimension[],
  convert: (value: number) => number
): PlayRadiusDimension[] {
  return dimensions.map((dim) => {
    const converted: PlayRadiusDimension = { name: dim.name };
    for (const key of Object.keys(dim)) {
      if (key !== "name") {
        converted[key] =
          typeof dim[key] === "number" ? convert(dim[key] as number) : dim[key];
      }
    }
    return converted;
  });
}

/** Convert all numeric dimension values from the display unit back to the backend base unit (m). */
export function convertDimensionsToBase(
  dimensions: PlayRadiusDimension[],
  convertBack: (value: number) => number
): PlayRadiusDimension[] {
  return dimensions.map((dim) => {
    const converted: PlayRadiusDimension = { name: dim.name };
    for (const key of Object.keys(dim)) {
      if (key !== "name") {
        converted[key] =
          typeof dim[key] === "number" ? convertBack(dim[key] as number) : dim[key];
      }
    }
    return converted;
  });
}
